// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2G2kL","large":"styles_large__1UaDM"};